export interface ApiGetClaimCompareTranslationRequest {
    patent_id: string;
    source_lang: string;  // patent 类型传语言值，text 类型传空字符串
    trans_lang: string;
    text: string[];
}

export interface ApiGetClaimCompareTranslationResponse {
    data: Record<string, string>;
}

export const GetClaimCompareTranslation = Symbol.for('GetClaimCompareTranslation');

export interface GetClaimCompareTranslation {
    getClaimCompareTranslation(request: ApiGetClaimCompareTranslationRequest): Promise<ApiGetClaimCompareTranslationResponse>;
}